module.exports = __webpack_public_path__ + "media/images/flags/tw-8ea0b61c9cced533d851df6fc6ad4fb7.svg";